import { useCallback, useEffect, useState } from "react";

export type TableViewMode = "table" | "cards";

/**
 * Persiste la vista (tabla | tarjetas) de un DataTable en localStorage,
 * por `tableId`. Mismo patrón que useColumnVisibility.
 */
export function useTableViewMode(
  tableId: string,
  defaultMode: TableViewMode = "table",
) {
  const storageKey = `table-view-${tableId}`;
  const [viewMode, setViewMode] = useState<TableViewMode>(defaultMode);

  // Cargar preferencia guardada al montar.
  useEffect(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored === "table" || stored === "cards") {
        setViewMode(stored);
      }
    } catch (error) {
      console.warn("Error loading table view mode from localStorage:", error);
    }
  }, [storageKey]);

  const changeViewMode = useCallback(
    (next: TableViewMode) => {
      setViewMode(next);
      try {
        localStorage.setItem(storageKey, next);
      } catch (error) {
        console.warn("Error saving table view mode to localStorage:", error);
      }
    },
    [storageKey],
  );

  return { viewMode, setViewMode: changeViewMode };
}
